export default class MainService {
  public static NODE_ENV: string | undefined = process.env.NODE_ENV;
  public static PLATFORM_TITLE: string | undefined = process.env.PLATFORM_TITLE;
  public static BASE_HOST: string | undefined = process.env.BASE_HOST;
  public static BACKEND_HOST: string | undefined = process.env.BACKEND_HOST;
  public static BACKEND_WEBSOCKET_HOST: string | undefined = process.env.BACKEND_WEBSOCKET_HOST;
  public static HELP_HOST: string | undefined = process.env.HELP_HOST;
  public static MAIN_APP_HOST: string | undefined = process.env.MAIN_APP_HOST;
  public static CUSTOM_APP_HOST: string | undefined = process.env.CUSTOM_APP_HOST;
  public static GOOGLE_MAPS_API_KEY: string | undefined = process.env.GOOGLE_MAPS_API_KEY;
  public static GOOGLE_MAPS_API_MAP_ID: string | undefined = process.env.GOOGLE_MAPS_API_MAP_ID;
  public static GOOGLE_MAPS_API_VERSION: string | undefined = process.env.GOOGLE_MAPS_API_VERSION;
  public static GOOGLE_TAG_MANAGER_ID: string | undefined = process.env.GOOGLE_TAG_MANAGER_ID;
  public static INTERCOM_APP_ID: string | undefined = process.env.INTERCOM_APP_ID;
  public static OKTA_DEV_MODE: string | undefined = process.env.OKTA_DEV_MODE;
  public static DISABLE_SSO: string | undefined = process.env.DISABLE_SSO;
  public static IS_MOBILE_APP: string | undefined = process.env.IS_MOBILE_APP;
  public static GOOGLE_PLAY_STORE_LINK: string | undefined = process.env.GOOGLE_PLAY_STORE_LINK;
  public static APPLE_APP_STORE_LINK: string | undefined = process.env.APPLE_APP_STORE_LINK;
}
